const BulkMailProjectManage = () => {
    return (
      <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          
            <div className="flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
              <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                Bulk Mail Project Management
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS leads and supports project managers working on bulk mail projects, by providing guidance and resolution 
              for difficult situations. MMS teams responsible for the day-to-day execution of bulk mail programmes 
              make sure that each job adheres to the process and quality procedures, ensuring high levels of accuracy.
              </p>
              
                
            </div>
            <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
              <img src="/MMs/bulk-mail.jpg" alt="" className="max-w-[100%] rounded-md"/>
            </div>
          </div>
          
        </div>
      </div>


      

      
    );
  };
  
  export default BulkMailProjectManage;